/**
 * Generated by orval v6.31.0 🍺
 * Do not edit manually.
 * Stitch Web
 * OpenAPI spec version: 0.0.53
 */

export type MedicalCodeRowCreationType =
	(typeof MedicalCodeRowCreationType)[keyof typeof MedicalCodeRowCreationType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const MedicalCodeRowCreationType = {
	ai: 'ai',
	template: 'template',
} as const;
